module.exports = {
  get (attribute, ...args) {
    const settings = INKIVE.EditorFacade.handle('header_and_footer', 'settings');

    switch (attribute) {
      case 'settings':
        return settings;
      case 'range':
        return findRangeByPageId(
          settings?.ranges ?? [],
          args[0] || INKIVE.PageFactory.getCurrentPageId()
        );
      case 'hasMultipleRanges': {
        if (!settings?.ranges || settings?.ranges?.length === 0) {
          return false;
        } else if (settings?.ranges?.length <= 1 && settings.ranges[0].range === 'all') {
          return false;
        } else {
          return true;
        }
      }
      case 'page':
        return settings.pages[args[0] || INKIVE.PageFactory.getCurrentPageId()];
      case 'enabled':
        return settings?.ranges?.length > 0;
      default:
        return settings;
    }
  }
};

function findRangeByPageId (ranges, pageId) {
  return ranges.find(range => range.pages.includes(pageId)) ||
    ranges.find(range => range.range === 'all') || {};
}
